import React from "react";
import { SiteData } from "../Data/SiteData";
import  { AttributeCollection, getNodeStyleAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";


export default function ApplyToGlobalButton({getCollectionFunc,layoutNode,siteData}:{layoutNode:AttributeCollection,siteData:SiteData,getCollectionFunc:getSiteCollectionFromNode}){


    return <>       
    <div className="global-apply-container">
                <button className="menu-button"
            onClick={()=>{

                let collection = getCollectionFunc(layoutNode);

                if(!collection)
                    return;

                let atts = {...layoutNode.screenSizeStyleAttributes[ScreenSize.Desktop]};

       
                atts = {...collection.screenSizeStyleAttributes[ScreenSize.Desktop],...atts};
                collection.screenSizeStyleAttributes[ScreenSize.Desktop] = atts;

                let width = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,"width");
                let height = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,"height");

                let pos = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.position);
                let left = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.left);
                let right = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.right);
                let top = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.top);
                let bottom = getNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.bottom);

       

                collection.screenSizeStyleAttributes[ScreenSize.Desktop] = atts;
                layoutNode.screenSizeStyleAttributes[ScreenSize.Desktop] = {}; // clear the button styel when its appied to the global style
                
                //clear width and height values
                setNodeStyleAttributeValue(collection,ScreenSize.Desktop,"width","");
                setNodeStyleAttributeValue(collection,ScreenSize.Desktop,"height","");
                setNodeStyleAttributeValue(collection,ScreenSize.Desktop,attributeTypes.position,"");

                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,"width",width);
                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,"height",height);

                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.position,pos);
                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.left,left);
                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.right,right);
                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.top,top);
                setNodeStyleAttributeValue(layoutNode,ScreenSize.Desktop,attributeTypes.bottom,bottom);



                siteData.onUpdateStyle();
                siteData.designer?.forceUpdate();
                //reapply to original
      
                }
            }
            
            >Apply to Global Style</button> 
         
            </div>
            </>
}


export type getSiteCollectionFromNode = (node:AttributeCollection)=>AttributeCollection|undefined;